let loggingDisabled = false

function remoteLog (url, agent, gtagType, clientId) {
  if (loggingDisabled) return

  const httpConfig = window.vue.getInstance('http')
  const rawUrl = httpConfig.mmp.gaDiagLogUrl
  const endpoint = httpConfig.mmp.httpConfig.baseURI + '/' + rawUrl.replace(/^\/+/, '')
  const promoStore = window.vue.getStore('promoInfo')
  const eduGroupCode = promoStore.state.promoInfo.eduGroupCode

  fetch(endpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ url, agent, gtagType, clientId, eduGroupCode }),
    keepalive: true
  }).then(res => res.json())
    .then(json => {
      if (json && json.data && json.data.logging === false) {
        loggingDisabled = true
      }
    })
    .catch(() => {})
}

function collect () {
  if (loggingDisabled) return

  const url = window.location.href
  const ag = navigator.userAgent
  /* global gtag */
  const gt = typeof gtag
  try {
    gtag('get', 'G-474FGT7L3T', 'client_id', function (id) {
      remoteLog(url, ag, gt, id)
    })
  } catch (e) {
    remoteLog(url, ag, gt, 'fail')
  }
}

const GaDiagLog = {
  install (Vue, options) {
    const routerObj = window.vue.getInstance('router')
    routerObj.afterEach(function (to, from) {
      collect()
    })
  }
}

export default GaDiagLog



// WEBPACK FOOTER //
// ./src/plugins/_common/GaDiagLog.js